export default __webpack_public_path__ + "0c57d3b9d9a96306bbfdc1ccfbf31468.png";